import { useCallback, useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useClientByIdQuery } from 'api';
import { ContactInfoFieldKeyType } from 'typings/form';
import { filterContactInfo, generateContactInfoList, shouldShowSeeMore } from 'utils/contactUtils';

export type ContactInfoGrouped = Record<ContactInfoFieldKeyType, string[]>;

export const useContactInfo = () => {
  const [modalState, setModalState] = useState<boolean>(false);
  const [isAllShown, setIsAllShown] = useState<boolean>(false);
  const [clientContactInfoList, setClientContactInfoList] = useState<
    {
      type: ContactInfoFieldKeyType;
      value: string;
      id: string;
    }[]
  >([]);
  const { id } = useParams() as { id: string };
  const { data: clientDetails = {} } = useClientByIdQuery({ id });

  const isSeeAllVisible = shouldShowSeeMore(clientDetails.contactInfo);
  const clientContactInfo = useMemo(() => {
    return filterContactInfo(clientDetails.contactInfo, isAllShown);
  }, [clientDetails.contactInfo, isAllShown]);
  const onModalStateChange = useCallback(() => setModalState((prevState) => !prevState), []);

  const onShowAllStateChange = useCallback(() => {
    setIsAllShown((prevState) => !prevState);
  }, []);

  useEffect(() => {
    if (modalState) {
      setClientContactInfoList(generateContactInfoList(clientDetails.contactInfo));
    }
  }, [modalState, clientDetails.contactInfo]);

  return {
    modalState,
    onModalStateChange,
    onShowAllStateChange,
    isAllShown,
    isSeeAllVisible,
    clientContactInfoList,
    clientContactInfo,
  };
};
